<app-integration
    [widgetRef]="widgetRef"
    [integrationInput]="integrationInput"
    [isConfigured]="isConfigured"
    [description]="widgetRef.widgetDescription"
    (onIntegrate)="openIntegrationsModal(tableData)"
></app-integration>
